import React from 'react'
import { useComplianceFrameworks } from 'src/components/async/complianceframework'
import { useCurrentAuditFrameworkIds } from 'src/components/async/model/audit/useCurrentAuditFrameworkIds'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'
import { LoadingFilterDropdown } from '../FilterDropdown.components'

export const OverviewFrameworkFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element | null => {
  const { data: frameworks, isLoading } = useComplianceFrameworks(true)
  // In an audit, offer only the frameworks that audit covers.
  const { frameworkIds: auditFrameworkIds, isLoading: auditLoading } =
    useCurrentAuditFrameworkIds()

  if (isLoading || auditLoading) {
    return (
      <LoadingFilterDropdown
        filterName={FilterName.DASHBOARD_FRAMEWORK}
        isNested={isNested}
      />
    )
  }

  const filterValues =
    frameworks
      ?.getItemsList()
      .filter(
        (framework) =>
          !auditFrameworkIds || auditFrameworkIds.has(framework.getId()),
      )
      .map((framework) => ({
        value: framework.getId(),
        label: framework.getName(),
      })) || []

  if (!filterValues.length) return null

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_FRAMEWORK}
      filterName={FilterName.DASHBOARD_FRAMEWORK}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
